<template>
	<transition name="ui--messages">
		<modal v-if="isOpen" class="ui ui--messages">
			<ElementList :entries="messageButtons" transitionName="message" />
		</modal>
	</transition>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
import { mutationTypes } from '../../types';
import { uiComponents } from '../../tools/viewState';
import UiBase from './base.vue';
export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.uiMessages,
		};
	},
	computed: {
		...mapState(['messages']),
		isOpen() {
			return this.messages.length > 0;
		},
		messageButtons() {
			return this.messages.map(entry => ({
				name: entry.id,
				title: entry.body,
				role: 'alert',
				meaning: entry.type,
				click: this.messageFunctionFactory(entry.id),
				mounted: entry.sticky ? undefined : this.messageFunctionFactory(entry.id, 15000), // if is sticky is set do not remove message
			}));
		},
	},
	methods: {
		...mapMutations([mutationTypes.removeMessage]),
		messageFunctionFactory(messageID, timer) {
			return () => {
				setTimeout(() => {
					this[mutationTypes.removeMessage]({ messageID });
				}, timer || 1);
			};
		},
	},
	mounted() {},
};
</script>
